@if (lineSize === 0) {
  <div class="checkbox-group" [ngClass]="orientation" [attr.disabled]="notEnabled?'':null"
    [style.marginTop.px]="marginTop">
    @for (so of options; track so) {
      <div class="checkbox">
        <aa-checkbox2 [toTranslate]="toTranslate" [option]="so"> </aa-checkbox2>
      </div>
    }
  </div>
}
@if (lineSize !== 0) {
  <div class="checkbox-group" [attr.disabled]="notEnabled?'':null"
    [style.marginTop.px]="marginTop">
    <table>
      @for (line of lines; track line; let i = $index) {
        <tr>
          @for (so of options.slice(i * lineSize, (i + 1) * lineSize); track so) {
            <td>
              <aa-checkbox2 [toTranslate]="toTranslate" [option]="so"> </aa-checkbox2>
            </td>
          }
        </tr>
      }
    </table>
  </div>
}
